<template>
  <section class="park" >
    <div class="park-search">
      <span class="park-title">停车场:</span>
      <el-cascader
            v-model="search.id"
            :options="parks"
            filterable
            :show-all-levels="false"
            @change="onParkChange"
            placeholder="请选择车位"
          ></el-cascader>
      <!-- <el-select
        class="park-parking"
        placeholder="请选择"
        clearable
        filterable
        v-model="search.parkingId"
        @change="onParkChange"
      >
        <el-option
          v-for="{ parkingId, parkingName } in parks"
          :key="parkingId"
          :value="parkingId"
          :label="parkingName"
        ></el-option>
      </el-select> -->
    </div>
    <div class="gap"></div>
    <section  v-if="search.id.length>=2">
    <section class="account-content">
      <div class="account balance">
        <img
          src="../../../assets/images/split-account/balance.svg"
          style="color:#10AEFF; width:80px;height:auto;"
        />
        <span>账户余额(元)</span>
        <el-divider></el-divider>
        <span>¥{{ profits.totalIncome }}</span>
        <!-- <span class="cash-out" @click="onWithdrawalbtn">去提现</span>-->
      </div>
      <div class="account add">
        <img
          src="../../../assets/images/split-account/balance.svg"
          style="color:#10AEFF;width:80px;height:auto;"
        />
        <span>可以提现金额(元)</span>
        <el-divider></el-divider>
        <span>¥{{ profits.withdrawIncome }}</span>
        <span class="cash-out"> 去提现</span>
      </div>
      <div class="account add">
        <img
          src="../../../assets/images/split-account/add.svg"
          style="color:#10AEFF;width:80px;height:auto;"
        />
        <span>今日新增(元)</span>
        <el-divider></el-divider>
        <span>¥{{ profits.todayIncome }}</span>
        <span class="cash-out"> 去提现</span>
      </div>
      <div class="account unposted">
        <img
          src="../../../assets/images/split-account/unposted.svg"
          style="color:#10AEFF;width:80px;height:auto;"
        />
        <span>未入账金额(元)</span>
        <el-divider></el-divider>
        <span>¥{{ profits.unrecorded }}</span>
      </div>
    </section>
    <section>
      <div class="gap"></div>
      <h6 class="summary-title">营收汇总</h6>
      <div class="gap"></div>
      <div>
        <el-tabs v-model="activeName" @tab-click="onTabClick">
          <el-tab-pane
            v-for="{ label, value } in dates"
            :key="value"
            :label="label"
            :name="value"
          >
            <transition name="el-fade-in">
              <el-table
                border
                style="width: 100%"
                :data="revenueSummary"
                :loading="summaryLoading"
              >
                <el-table-column prop="type" label="业务类型" width="180">
                </el-table-column>
                <el-table-column
                  prop="totalAmount"
                  label="交易总额"
                  width="180"
                >
                </el-table-column>
                <el-table-column prop="totalAmount" label="渠道手续费">
                </el-table-column>
                <el-table-column prop="profit" label="服务分成">
                </el-table-column>
                <el-table-column prop="volumeAmount" label="优惠券金额">
                </el-table-column>
                <el-table-column prop="settleAmount" label="结算金额">
                </el-table-column>
                <!-- <el-table-column label="操作"> </el-table-column> -->
              </el-table>
            </transition>
          </el-tab-pane>

          <!-- <el-tab-pane disabled>
            <span slot="label">
              缴费时间:<el-date-picker
                type="datetimerange"
                placeholder="选择日期时间"
              ></el-date-picker>
              <el-icon
                key=""
                class="el-icon-search"
                style="margin: 0px 5px;"
              ></el-icon>
            </span>
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </section>
   
  </section>
  <section v-else style="display:flex;justify-content: center; align-items: center;">暂无数据</section>
  </section>
</template>
<script>
import { shareParkCascade, profitInfos, profitRevenueSummary } from "@/api/url";
export default {
  data() {
    return {
      parks: [],
      dates: [
        {
          label: "今日",
          value: "1",
          name: "today",
        },
        {
          label: "昨日",
          value: "2",
          name: "yesterday",
        },
        {
          label: "上周",
          value: "3",
          name: "lastWeek",
        },
        {
          label: "上月",
          value: "4",
          name: "lastMonth",
        },
      ],
      // dates: {
      //   today: "今日",
      //   yesterday: "昨日",
      //   lastWeek: "上周",
      //   lastMonth: "上月",
      // },
      activeName: "1",
      search: {
        id: [],
      },
      profits: {},
      revenueSummary: [],
      summaryLoading: false,
    };
  },
  mounted: function() {
    this.getShareParks();
    // this.$message({
    //   message: "请选择停车位",
    //   type: "warning",
    // })
    // this.search.parkingId = this.parks?.[0]?.parkingId;
    // this.getProfitInfos(this.parks?.[0]?.parkingId);
    // this.getProfitRevenueSummary(this.parks?.[0]?.parkingId, 1);
  },
  methods: {
    // async getShareParks() {
    //   return this.$postRequest(shareParks(), {}).then((res) => {
    //     this.parks = res?.data?.data?.rows ?? [];
    //   });
    // },
    onWithdrawalbtn() {
      this.$router.push({
        path: "/main/split-accounting/withdrawal",
        query: { type: "park" },
      });
    },
    getProfitInfos(id) {
      this.profitLoading = true;
      this.$get(profitInfos(), { type: 2, id }).then((res) => {
        this.profits = res?.data ?? {};
      }).finally(()=>{
        this.profitLoading = false; 
      });
    },
    getProfitRevenueSummary(id, dateType) {
      this.summaryLoading = true;
      this.$get(profitRevenueSummary(), { type: 2, id, dateType })
        .then((res) => {
          const data = [];
          const resData = { ...(res?.data ?? {}) };
          delete resData.settlementTime;
          Object.entries({ ...resData }).forEach(([key, value]) => {
            data.push({
              type: value?.type??"",
              totalAmount: value?.totalAmount ?? "",
              poundage: value?.poundage ?? "",
              profit: value?.profit ?? "",
              coupon: value?.couponFee,
              volumeAmount: value?.volumeAmount ?? "",
              settleAmount: value?.settleAmount ?? "",
            });
          });
          this.revenueSummary = [...data];
        })
        .finally((res) => {
          this.summaryLoading = false;
        });
    },
    onTabClick(e) {
      const { name } = e;
      this.getProfitRevenueSummary(this.search.id[this.search.id.length-1], name);
    },
    onParkChange(){
      if(this.search.id?.length <2) return;
      this.getProfitRevenueSummary(this.search.id[this.search.id.length-1], this.activeName);
      this.getProfitInfos(this.search.id[this.search.id.length-1],);
    },
    getShareParks() {
      this.$get(shareParkCascade()).then((res) => {
        if (res?.status == 200) {
          this.parks = res?.data ?? [];
        
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style scoped>
.park {
  padding: 20px;
  height: 100%;
  overflow: auto;
}
.park-search {
  display: flex;
  align-items: center;
}
.park-title {
  color: #666;
  font-weight: bold;
  font-size: 18px;
  margin-right: 10px;
}
.park-parking {
  width: 300px;
}
.account-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.account {
  width: 22%;
  height: 220px;
  text-align: center;
  border: 1px solid #eee;
  border-radius: 10px;
  margin: 0 auto;
  padding: 15px;
  box-sizing: border-box;
}
.account span {
  display: block;
  color: #777;
  font-size: 18px;
  font-weight: bold;
  padding: 5px 0;
  box-sizing: border-box;
}
span.cash-out {
  width: 150px;
  height: 30px;
  background: #188fff;
  color: white;
  margin: 0 auto;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
}
.summary-title {
  font-size: 20px;
  color: #666;
  font-weight: bold;
}
.gap {
  height: 20px;
}
</style>
<style>
.park .el-divider--horizontal {
  margin: 0;
}
</style>
